/**
 * Created by Jew on 5/26/2017.
 */
import {Component, OnInit} from '@angular/core';

@Component({
   selector: 'app-term-of-use',
   templateUrl: './terms.component.html',
   styleUrls: ['./terms.component.css']
})
export class TermOfUseComponent implements OnInit {
   lang: string;

   ngOnInit(): void {
      this.lang = localStorage.getItem('lang') || 'en';
      setTimeout(() => {
         window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
      }, 100);
   }
}
